
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"21","viewBox":"0 0 24 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.8619 16.322C22.5551 13.9516 22.0073 10.7016 19.592 9.01549C17.1766 7.32938 13.8648 7.89142 12.1467 10.2617C10.4534 12.6321 11.0012 15.8821 13.4166 17.5682C15.1347 18.7656 17.4007 18.8633 19.2184 17.8126L21.1856 19.6942C21.6089 20.134 22.3061 20.1585 22.7543 19.7431C23.2025 19.3276 23.2274 18.6434 22.8041 18.2036C22.7792 18.1791 22.7792 18.1791 22.7543 18.1547L20.8619 16.322ZM16.5043 16.6641C14.6118 16.6641 13.068 15.149 13.068 13.2919C13.068 11.4347 14.6118 9.91964 16.5043 9.91964C18.3967 9.91964 19.9406 11.4347 19.9406 13.2919C19.9406 15.149 18.3967 16.6641 16.5043 16.6641Z"}}),_c('path',{attrs:{"d":"M18.6297 2.36731H1.62954C0.881535 2.36731 0.269531 1.90025 0.269531 1.32941C0.269531 0.75856 0.881535 0.291504 1.62954 0.291504H18.6297C19.3777 0.291504 19.9897 0.75856 19.9897 1.32941C19.9897 1.90025 19.3777 2.36731 18.6297 2.36731Z"}}),_c('path',{attrs:{"d":"M8.32222 8.59485H1.55796C0.849325 8.59485 0.269531 8.12779 0.269531 7.55694C0.269531 6.9861 0.849325 6.51904 1.55796 6.51904H8.32222C9.03085 6.51904 9.61065 6.9861 9.61065 7.55694C9.61065 8.12779 9.03085 8.59485 8.32222 8.59485Z"}}),_c('path',{attrs:{"d":"M5.12828 14.8224H1.63819C0.885429 14.8224 0.269531 14.3553 0.269531 13.7845C0.269531 13.2136 0.885429 12.7466 1.63819 12.7466H5.12828C5.88104 12.7466 6.49694 13.2136 6.49694 13.7845C6.49694 14.3553 5.88104 14.8224 5.12828 14.8224Z"}})])
          )
        }
      }
    